<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <div>
                <v-container>
                  <v-row>
                    <span v-if="mode === 'register'">
                      こちらの内容でIPsec回線を追加します。よろしいですか？
                    </span>
                    <span v-else-if="mode === 'modify'">
                      こちらの内容でIPsec回線設定を変更します。よろしいですか？
                    </span>
                    <span v-else>
                      こちらの内容でIPsec回線設定を削除します。よろしいですか？
                    </span>
                  </v-row>

                  <div class="mt-3" v-for="(line, index) in lines" :key="index">
                    <v-divider v-if="index !== 0" class="my-3"></v-divider>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="IPsecGW回線番号"
                          :value="line.gw.enumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="回線数合計"
                          :value="
                            gwOfIpsec[line.enumber] +
                            '/' +
                            line.gw.upperLimitIpsec
                          "
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="mode !== 'register'">
                      <v-col cols="12">
                        <app-label-group
                          label="IPsec回線番号"
                          :value="line.xnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="IPsec回線名"
                          :value="line.ipsecLineName"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="USER-FQDN"
                          :value="`${line.userAccount}@${line.gw.suffix}`"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="事前共有鍵"
                          :value="line.preSharedKey"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="疎通試験用IPアドレス"
                          :value="line.connectTestIpAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <app-label-group label="LANアドレス">
                          <template #value>
                            <div v-if="sortedLanIpAddressList(line).length > 0">
                              <div class="d-flex">
                                <div class="pa-0">
                                  <p
                                    class="m-0 ml-3"
                                    v-for="i in 25"
                                    :key="i - 1"
                                  >
                                    <template
                                      v-if="sortedLanIpAddressList(line)[i - 1]"
                                    >
                                      {{
                                        sortedLanIpAddressList(line)[i - 1]
                                          .ipAddress
                                      }}
                                    </template>
                                  </p>
                                </div>
                                <div class="pa-0">
                                  <p
                                    class="m-0 ml-3"
                                    v-for="i in 25"
                                    :key="i + 24"
                                  >
                                    <template
                                      v-if="
                                        sortedLanIpAddressList(line)[i + 24]
                                      "
                                    >
                                      {{
                                        sortedLanIpAddressList(line)[i + 24]
                                          .ipAddress
                                      }}
                                    </template>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="ml-3" v-else>-</div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group
                          label="備考"
                          :value="$filter.emptyTo(line.description, '-')"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <v-divider class="mt-3"></v-divider>
                  <!-- オーダー備考 -->
                  <v-row class="mt-3">
                    <v-col>
                      <app-badge
                        item="オーダー備考"
                        msg="200文字以内"
                        :isRequired="false"
                      />
                      <validation-provider
                        name="note"
                        label="オーダー備考"
                        v-model="note"
                        :rules="{ required: false, max: { length: 200 } }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-textarea
                          rows="3"
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          :field-meta="meta"
                        />
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">はい</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >いいえ</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type { IpSecLineWithGW } from "@/views/nwSetting/ipSecLine/IpSecLineList.vue";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "IpSecLineViewCD",
  props: {
    /** 確認モード（register, modify, delete） */
    mode: {
      type: String as PropType<"register" | "modify" | "delete">,
      required: true,
    },
    /** 表示対象IPsec回線 + IPsecGW（複数） */
    lines: {
      type: Array as PropType<IpSecLineWithGW[]>,
      required: true,
    },
  },
  data() {
    return {
      note: "",
    };
  },
  computed: {
    /** key: E番号, value: 追加、変更、削除した場合の想定回線件数 */
    gwOfIpsec(): Record<string, number> {
      // 現在のIPsec回線数
      const nowIpsec = this.lines
        .uniq((e) => e.enumber)
        .toMap(
          (e) => e.enumber,
          (e) => e.gw.numberOfIpsec
        );
      if (this.mode === "modify") {
        // 変更は回線件数に変更はないので現在数を返却
        return nowIpsec;
      }

      // E番号ごとに想定回線件数を集計
      return this.lines.reduce(
        (acc, e) => {
          const ipsec: number | undefined = acc[e.enumber];
          if (ipsec) {
            return {
              ...acc,
              [e.enumber]: this.mode === "register" ? ipsec + 1 : ipsec - 1,
            };
          } else {
            return {
              ...acc,
              [e.enumber]:
                this.mode === "register"
                  ? nowIpsec[e.enumber] + 1
                  : nowIpsec[e.enumber] - 1,
            };
          }
        },
        {} as Record<string, number>
      );
    },
  },
  methods: {
    async submit() {
      (
        this.$refs.modal as typeof VueFinalModal & {
          ok: (node: string | null) => void;
        }
      ).ok(this.note ? this.note : null);
    },
    sortedLanIpAddressList(line: IpSecLineWithGW) {
      // modeが'modify'の場合は、変更画面の順番通りに表示
      if (this.mode === "modify") {
        return line.lanIpAddressList;
      }
      // それ以外はIPアドレスで昇順ソート
      return [...line.lanIpAddressList].sort((a, b) =>
        sortCompare(a, b, [["ipAddress", "asc"]])
      );
    },
  },
});
</script>
